import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';

import { getAovProgressBarRoutes } from './aovprogressbar';
import { getBackInStockRoutes } from './backinstock';
import { getReviewsRoutes } from './reviews';
import { getRecommenderRoutes } from './recommender';
import { getReperksRoutes } from './reperks';
import { getPromptRoutes } from './prompt';
import constants from 'Constants';
import * as paths from 'Paths';



const getExtensionsRoutes = () => {
  return [
    ...getAovProgressBarRoutes(),
    ...getBackInStockRoutes(),
    ...getReviewsRoutes(),
    ...getRecommenderRoutes(),
    ...getReperksRoutes(),
    ...getPromptRoutes(),
  ]
}


export { getExtensionsRoutes };
